import React, { useState, } from 'react';
import { Platform, StyleSheet, Text, TouchableOpacity, View, Dimensions, Image, } from 'react-native';
import { TypographyTypeDLS, ButtonTypeDLS, TextAlignTokens, IconTokens, ColorTokens, ButtonSizeDLS, FontFamilyTokens, FontSizeTokens, IconSizeTokens, } from '@voltmoney/schema';
import { ModalAlignmentEnum, } from '@voltmoney/types';
import { Typography } from '../../typography/Typography';
import { addCommasToNumber } from '../utils';
import { Icon } from '../../icon/Icon';
import BottomSheet from '../BottomSheet';
import BoilerPlate from '../boilerPlate/BoilerPlate';
import ButtonDLSBase from '../../button/ButtonDLS.base';
import * as Animatable from 'react-native-animatable';
// import LottieView from "lottie-react-native";
const PhonePayPage = ({ height, interestDueAmount, contactSupportAction, backAction, triggerAction, }) => {
    const [showWhatsappCard, setShowWhatsappCard] = useState(false);
    const bodyAnimated = () => {
        return (React.createElement(View, { style: styles.bodyContainer },
            React.createElement(Text, { style: { fontSize: 32 } }, "\uD83C\uDF89"),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'You are ready to unlock your credit limit' }),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#F1F3F5',
                    width: 130,
                    marginTop: 24,
                    marginBottom: 24,
                } }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, textAlign: TextAlignTokens.center, label: 'Complete your application in just\n5 mins!' }),
            React.createElement(View, { style: styles.view1 },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Your credit limit' }),
                React.createElement(Text, null,
                    React.createElement(Typography, { fontFamily: FontFamilyTokens.Inter, fontSize: FontSizeTokens.XXXXL, color: ColorTokens.Secondary_100, label: '₹', fontWeight: '700', lineHeight: 40 }),
                    React.createElement(Typography, { typeDLS: TypographyTypeDLS.H1B, label: `${addCommasToNumber(interestDueAmount)}`, color: ColorTokens.Secondary_100 }))),
            React.createElement(Animatable.View, { animation: 'zoomIn', delay: 500, duration: 1000, style: { marginTop: 32, width: '100%' } },
                React.createElement(ButtonDLSBase, { onPress: () => {
                        setShowWhatsappCard(true);
                    }, typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.LARGE, iconName: IconTokens.Download, label: 'Download Volt Money Now' })),
            React.createElement(Animatable.View, { animation: 'slideInUp', delay: 1000, duration: 1000, style: {
                    flexDirection: 'row',
                    marginTop: 8,
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Available on', color: ColorTokens.Grey_Smoke }),
                React.createElement(Image, { source: {
                        uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/65f9cb6caca2c8495541c73d012ae77b679892f4dada2d8eb410c8b9d5b3b569?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                    }, style: styles.image2 }),
                React.createElement(Image, { source: {
                        uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/0e66cbbeea02146197d456ed8115023b851967fed06fcaa956a7a7e1c74ec03d?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                    }, style: styles.image3 }))));
    };
    const whatsAppCard = () => {
        return (React.createElement(View, { style: {
                alignContent: 'center',
                alignItems: 'center',
                padding: 24,
            } },
            React.createElement(Icon, { name: IconTokens.SYSTEM_STATUS_SUCCESS_DLS, size: IconSizeTokens.XXXXXXL, color: ColorTokens.Secondary_100 }),
            React.createElement(View, { style: { marginTop: 16 } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H4S, label: 'Volt app link sent on Whatsapp!' })),
            React.createElement(View, { style: { marginTop: 24 } },
                React.createElement(Typography, { color: ColorTokens.Grey_Charcoal, textAlign: TextAlignTokens.center, typeDLS: TypographyTypeDLS.B1R, label: 'Download Volt through the link and complete your loan application in 5 mins!' })),
            React.createElement(View, { style: { marginTop: 24, width: '100%' } },
                React.createElement(ButtonDLSBase, { onPress: () => {
                        if (backAction) {
                            triggerAction(backAction);
                        }
                    }, typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.MEDIUM, iconName: IconTokens.Whatsapp, label: 'Open Whatsapp' })),
            React.createElement(View, { style: {
                    marginTop: 24,
                    width: '100%',
                    alignContent: 'center',
                    alignItems: 'center',
                    alignSelf: 'center',
                } },
                React.createElement(Text, null,
                    React.createElement(Typography, { textAlign: TextAlignTokens.center, typeDLS: TypographyTypeDLS.B1R, label: 'Need help? ' }),
                    React.createElement(TouchableOpacity, { onPress: () => {
                            if (contactSupportAction) {
                                triggerAction(contactSupportAction);
                            }
                        } },
                        React.createElement(Typography, { textAlign: TextAlignTokens.center, typeDLS: TypographyTypeDLS.B1S, label: 'Contact us', color: ColorTokens.Primary_100 }))))));
    };
    const body = () => {
        return (React.createElement(View, { style: styles.bodyContainer },
            React.createElement(Text, { style: { fontSize: 32 } }, "\uD83C\uDF89"),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.B1R, label: 'You are ready to unlock your credit limit' }),
            React.createElement(View, { style: {
                    height: 1,
                    backgroundColor: '#F1F3F5',
                    width: 130,
                    marginTop: 24,
                    marginBottom: 24,
                } }),
            React.createElement(Typography, { typeDLS: TypographyTypeDLS.H3S, textAlign: TextAlignTokens.center, label: 'Complete your application in just\n5 mins!' }),
            React.createElement(View, { style: styles.view1 },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Your credit limit' }),
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.H1B, label: '30,000', color: ColorTokens.Secondary_100 })),
            React.createElement(View, { style: { marginTop: 32, width: '100%' } },
                React.createElement(ButtonDLSBase, { typeDLS: ButtonTypeDLS.PRIMARY, sizeDLS: ButtonSizeDLS.LARGE, iconName: IconTokens.Download, label: 'Download Volt app now' })),
            React.createElement(View, { style: {
                    flexDirection: 'row',
                    marginTop: 8,
                } },
                React.createElement(Typography, { typeDLS: TypographyTypeDLS.B2R, label: 'Available on', color: ColorTokens.Grey_Smoke }),
                React.createElement(Image, { source: {
                        uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/65f9cb6caca2c8495541c73d012ae77b679892f4dada2d8eb410c8b9d5b3b569?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                    }, style: styles.image2 }),
                React.createElement(Image, { source: {
                        uri: 'https://cdn.builder.io/api/v1/image/assets/TEMP/0e66cbbeea02146197d456ed8115023b851967fed06fcaa956a7a7e1c74ec03d?apiKey=9f1d109009654dbd90811ff4ef0340af&',
                    }, style: styles.image3 }))));
    };
    const renderWhatsAppHalfCard = () => {
        return (showWhatsappCard && (React.createElement(View, { style: { position: 'absolute', bottom: 0 } },
            React.createElement(BottomSheet, { autoAdjustHeight: false, height: 360, closeFunction: () => {
                    setShowWhatsappCard(false);
                }, alignment: ModalAlignmentEnum.BOTTOM, backgroundColor: 'transparent', hasDraggableIcon: false, sheetBackgroundColor: 'white', isDismissible: true, radius: 4, screenHeight: height, screenWidth: Dimensions.get('window').width, routeId: 'routeId', handleKeyboard: true }, whatsAppCard()))));
    };
    return (React.createElement(BoilerPlate, { height: height, bottomChildren: renderWhatsAppHalfCard() },
        React.createElement(React.Fragment, null, bodyAnimated())));
};
const styles = StyleSheet.create({
    container: {
        marginHorizontal: -16,
    },
    bodyContainer: {
        alignContent: 'center',
        alignItems: 'center',
        width: '100%',
        flexDirection: 'column',
        padding: 16,
        marginTop: 32,
    },
    overlay: {
        ...StyleSheet.absoluteFillObject,
        justifyContent: 'center',
        alignItems: 'center',
        width: '100%',
        height: '100%',
    },
    image2: { position: 'relative', width: 20 },
    image3: { position: 'relative', width: 20 },
    circle: {
        width: 40,
        height: 40,
        borderRadius: 20,
        backgroundColor: '#F3F5FC',
        justifyContent: 'center',
        alignItems: 'center',
    },
    headerStyle: {
        ...(Platform.OS === 'ios' && {
            marginTop: 24,
        }),
    },
    successCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
    },
    successLottie: { width: 70, height: 'auto' },
    halfCardTitle: { marginTop: 16 },
    halfCardDescription: { marginTop: 4 },
    successCTA: {
        marginTop: 24,
        position: 'absolute',
        bottom: 0,
        marginBottom: 16,
        width: '94%',
    },
    bottomNoteContainer: {
        backgroundColor: '#FDF7E7',
        flexDirection: 'row',
        padding: 12,
        borderBottomRightRadius: 12,
        borderTopWidth: 1,
        borderColor: '#E4E7EC',
        borderBottomLeftRadius: 12,
        justifyContent: 'flex-start',
    },
    modalView: {
        justifyContent: 'flex-end',
    },
    contentContainer: {
        paddingHorizontal: 16,
        flex: 1,
    },
    failureCard: {
        alignItems: 'center',
        flex: 1,
        height: 270,
        padding: 16,
        justifyContent: 'space-between',
    },
    userCancelledCard: {
        alignItems: 'center',
        flex: 1,
        height: 260,
        padding: 16,
        justifyContent: 'space-between',
    },
    whyAutoPay: {
        flex: 1,
        padding: 16,
        justifyContent: 'space-between',
    },
    whyAutoPayDesc: { marginTop: -24 },
    whyAutoPayCTA: {
        width: '100%',
        alignItems: 'center',
        alignContent: 'center',
        alignSelf: 'center',
        justifyContent: 'flex-end',
    },
    view1: {
        alignSelf: 'stretch',
        borderRadius: 16,
        boxShadow: '0px 20px 40px 0px rgba(12, 25, 86, 0.08)',
        borderColor: 'rgba(241, 243, 245, 1)',
        borderStyle: 'solid',
        borderWidth: 1,
        backgroundColor: '#FFF',
        marginTop: 24,
        padding: 16,
        width: '100%',
        height: 100,
    },
    errorCTA: {
        width: '100%',
        marginTop: 16,
        flexDirection: 'column',
    },
    landingTitle: {
        marginTop: 24,
        marginBottom: 16,
    },
    bankDetailsCard: {
        paddingTop: 16,
        paddingLeft: 16,
        paddingRight: 16,
        paddingBottom: 12,
    },
    accountDetails: {
        flexDirection: 'row',
        justifyContent: 'space-between',
    },
    accountContent: {
        width: 180,
        flexDirection: 'column',
    },
    autoDebitCard: {
        flexDirection: 'row',
        justifyContent: 'space-between',
        padding: 16,
    },
    mandateInfoImage: { marginTop: 2 },
    lineStyle: {
        borderWidth: 0.1,
        borderColor: '#E4E7EC',
    },
    bankCardContainer: {
        width: '100%',
        borderWidth: 1,
        borderRadius: 12,
        borderColor: '#E4E7EC',
        flexDirection: 'column',
        alignSelf: 'center',
    },
});
// @ts-ignore
export default PhonePayPage;
